import {message} from '@sail/intl';

export const messages = {
  // Input
  inputHeader: message({
    id: 'connectEmbedLib.fileUploader.inputHeader',
    defaultMessage: 'Upload files',
    description: 'Upload files text for the file input',
  }),

  supportedFiles: message<{
    acceptableFileTypes: React.ReactElement | React.ReactNode;
    maxSize: React.ReactElement | React.ReactNode;
  }>({
    id: 'connectEmbedLib.fileUploader.supportedFiles',

    defaultMessage: `Accepted file types: {acceptableFileTypes}.{maxSize, select,
      undefined {}
      other { Total must not exceed {maxSize} MB.}
    }`,

    description: 'Supporting text for the file input',
  }),

  uploadFilesFallbackMessage: message({
    id: 'connectEmbedLib.fileUploader.uploadFilesFallbackMessage',

    defaultMessage:
      'Upload a file by clicking on this item and then selecting a file',

    description:
      'Message shown to the user with instructions on how to upload a file',
  }),

  // File size progress bar
  totalSize: message<{
    remainingSize: React.ReactElement | React.ReactNode;
    maxSize: React.ReactElement | React.ReactNode;
  }>({
    id: 'connectEmbedLib.fileUploader.totalSize',
    defaultMessage: '{remainingSize} MB available | Max {maxSize} MB',
    description: 'Total size of the supporting evidence files',
  }),

  // File list item
  download: message({
    id: 'connectEmbedLib.fileUploader.download',
    defaultMessage: 'Download file',
    description: 'Label text for downloading file',
  }),

  remove: message({
    id: 'connectEmbedLib.fileUploader.remove',
    defaultMessage: 'Remove file',
    description: 'Label text for removing file',
  }),

  selectCategory: message({
    id: 'connectEmbedLib.fileUploader.selectCategory',

    description:
      'Label for a select option to indicate to the user to select a dispute evidence category for an uploaded file',

    defaultMessage: 'Select a category',
  }),

  selectFile: message({
    id: 'connectEmbedLib.fileUploader.selectFile',

    description: 'Label for button in which user can select a file',

    defaultMessage: 'Select file',
  }),

  orDragAndDropHere: message({
    id: 'connectEmbedLib.fileUploader.orDragAndDrop',

    description: 'label for drag/drop option in file upload',

    defaultMessage: 'or drag and drop here',
  }),

  fileProcessingFailure: message({
    id: 'connectEmbedLib.fileUploader.fileProcessingFailure',
    defaultMessage: 'Error processing file',

    description:
      'Message to inform the user that the file upload or retrieval failed.',
  }),

  fileUploadRetry: message({
    id: 'connectEmbedLib.fileUploader.fileUploadRetry',
    defaultMessage: 'Retry',
    description: 'Button for the user to retry the file upload.',
  }),

  fileSize: message<{
    size: React.ReactElement | React.ReactNode;
  }>({
    id: 'connectEmbedLib.fileUploader.fileSize',
    defaultMessage: '{size} MB',
    description: 'Size of file item',
  }),

  uploadedFilePlaceholder: message({
    id: 'connectEmbedLib.fileUploader.uploadedFilePlaceholder',

    description:
      'Placeholder for an uploaded file that does not have a file name',

    defaultMessage: 'Uploaded file',
  }),

  fileUploadFailure: message({
    id: 'connectEmbedLib.fileUploader.fileUploadFailure',
    defaultMessage: 'Error uploading file.',
    description: 'Message to inform the user that the file upload failed.',
  }),

  fileRetrieveFailure: message({
    id: 'connectEmbedLib.fileUploader.fileRetrieveFailure',
    defaultMessage: 'Error retrieving file from server.',
    description: 'Message to inform the user that the file retrieval failed.',
  }),
};
